import Concierge from "../components/Concierge/Concierge";

export default function ConciergePage() {
    return (
        <div className='outletConainer'>
            <Concierge />
        </div>
    )
}